"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitPaymentWithoutDetails = exports.selectPayment = exports.paymentSlice = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const initialState = {
  loading: false,
  error: null
};
const submitPaymentWithoutDetails = exports.submitPaymentWithoutDetails = (0, _toolkit.createAsyncThunk)('payment/submitPaymentWithoutDetails', async (_, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const payment = await (0, _api.submitPaymentWithoutDetails)();
    return payment;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const paymentSlice = exports.paymentSlice = (0, _toolkit.createSlice)({
  name: 'paymentSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(submitPaymentWithoutDetails.pending, state => {
      state.loading = true;
    });
    builder.addCase(submitPaymentWithoutDetails.fulfilled, state => {
      state.loading = false;
    });
    builder.addCase(submitPaymentWithoutDetails.rejected, (state, _ref2) => {
      let {
        payload
      } = _ref2;
      state.loading = false;
      if (payload !== null && payload !== void 0 && payload.includes("Order doesn't have paymentMethodId")) {
        state.error = {
          message: 'Unable to proceed, because of wrong offer settings. Please, contact the owner of the offer',
          translationKey: 'free-offer.error.wrong-offer-settings'
        };
      } else {
        state.error = {
          message: 'Oops, something went wrong! Please, reload the page and try again',
          translationKey: 'free-offer.error.something-went-wrong'
        };
      }
    });
  }
});
const selectPayment = state => state.payment;
exports.selectPayment = selectPayment;
var _default = exports.default = paymentSlice.reducer;